import { createActionTypes } from "@helpers/redux-helpers";

export const addCardActionTypes = createActionTypes("cards/add");
export const getCardsActionTypes = createActionTypes("cards/get/list");
export const deleteCardActionTypes = createActionTypes("cards/delete");
